import Backbone from "backbone";

export default class SearchView extends Backbone.View {
    initialize() {
        this.$el.find("input").autocomplete({
            source: this.autocomplete.bind(this),
            minLength: 2,
            position: { my: "left top", at: "left bottom", collision: "none" }
        });
    }
    autocomplete(request, response) {
        $.ajax({
            url: "/public-rest/search/autocomplete/",
            dataType: "json",
            data: {
                q: request.term
            },
            success: function (data) {
                response(data);
            }
        });

    }
}



// WEBPACK FOOTER //
// ./frontend/js/views/search.js